/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Table, Form, Grid, Button, Pagination, Loader } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const eventTypeRegex = new RegExp("^[A-Za-z][A-Za-z- ]*");

const logListBeginMultiplier = 50;
const logListEndMultiplier = 49;

const UtilsInstance = new Utils();
var shouldPaintRowWithGreyColor = true;

var timeNow = new Date().getTime();

class EventLogOLM extends Component {

  // Intialize this component state with an empty log list
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      originalLogList: [],
      activeLogList: [],
      filteredLogList: [],
      currentPage: 1,
      isLoadingActive: false,
      // Controller para cancelar requests caso saia da tela
      controller: new AbortController(),
    };
  }

  showLoading = () => this.setState({ isLoadingActive: true })
  hideLoading = () => this.setState({ isLoadingActive: false })

  handleEventTypeSearch = () => {
    const searchedLogEntries = [];

    for (let i = 0; i < this.state.originalLogList.length; i++) {
      if (this.state.originalLogList[i].typeText.toUpperCase().includes(this.state.formInput.toUpperCase())) {
        searchedLogEntries.push(this.state.originalLogList[i]);
      }
    }
    // Show all entries that matched the event number on the form or none
    if (searchedLogEntries.length > 0) {
      this.setState({ filteredLogList: searchedLogEntries }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    } else {
      this.setState({ filteredLogList: [] }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    }
  }

  // Refreshes the page
  handleRefreshButtonClick = () => {
    this.setState({ filteredLogList: [], currentPage: 1, formInput: "" }, () => {
      document.getElementById("inputform").value = "";
      this.retrieveData();
    });
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  /*
    Handles user form submit 
    Filters the page list showing only the devices that match the event type
  */
  handleSubmit = () => {
    // Before doing any searches we empty the filtered log list and set
    // the current page to 1 to avoid problems
    this.setState({ filteredLogList: [], currentPage: 1 }, () => {
      if (this.state.formInput !== "" && eventTypeRegex.test(this.state.formInput)) {
        this.handleEventTypeSearch();
      }
      else if (this.state.formInput === "") {
        this.buildAndRenderPagination(this.state.originalLogList.length);
        this.buildAndRenderActiveLogPage(this.state.currentPage);
      }
      else {
        alert(Strings.INSERT_VALID_ADDRESS_OR_TYPE);
      }
    });
  }

  retrieveData = () => {
    timeNow = new Date().getTime();
    this.showLoading();
    // Retrieve paginated log
    fetch(Constants.REQUEST_IP_ADDRESS + "fiber/log", { mode: "cors", signal: this.state.controller.signal })
      .then(res => res.json())
      .then(data => this.setState({ originalLogList: this.changeEventTypeToReadableDescr(data) }, () => {
        this.hideLoading();
        this.buildAndRenderPagination(data.length);
        this.buildAndRenderActiveLogPage(this.state.currentPage);
      }))
      .catch((e) => {
        console.log("Request interrupted: ", e);
      });
  }

  changeEventTypeToReadableDescr = (logList) => {
    let modifiedLogList = [...logList];

    for (let i = 0; i < modifiedLogList.length; i++) {
      modifiedLogList[i].typeText = this.getTypeText(modifiedLogList[i].type);
    }

    return modifiedLogList;
  }

  getTypeText = (problemType) => {
    if (problemType === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
      return Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER;
    }
    else if (problemType === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
      return Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER;
    }
    else if (problemType === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      return Strings.FIBER_SIGNAL_LOSS_LIST_HEADER;
    }
    else {
      return Strings.UNKNOWN;
    }
  }

  formatTime = (logEntry) => {
    if (logEntry.ntp !== null && logEntry.ntp === true) {
      let parsedMillis = Date.parse(logEntry.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (logEntry.time !== undefined && logEntry.time !== null) {
      const eventTimeInMillis = logEntry.time * 1000;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  /*
    Each page will show a maximum of 50 log entries
  */
  buildAndRenderPagination = (numOfLogEntries) => {
    // The number of pages should be the highest integer number after (log entries / 50)
    const numOfPages = Math.ceil(numOfLogEntries / 50);
    const pagination = <Pagination
      firstItem={null}
      lastItem={null}
      boundaryRange={1}
      defaultActivePage={this.state.currentPage}
      siblingRange={1}
      totalPages={numOfPages}
      onPageChange={this.handlePageChange} />;
    ReactDOM.render(pagination, document.getElementById("pagination-container"));
  }

  handlePageChange = (e, { activePage }) => {
    this.setState({ currentPage: activePage }, () => {
      // If the user came from a livelist click or has filtered the log
      if (this.state.filteredLogList.length > 0) {
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      }
      else {
        this.buildAndRenderActiveLogPage(this.state.currentPage);
      }
    });
  }

  buildAndRenderActiveLogPage = (activePageNumber) => {
    const listBeg = (activePageNumber - 1) * logListBeginMultiplier;         // Multiples of 50 (starting with 0)
    const listEnd = listBeg + logListEndMultiplier;                          // Multiples of 49 (49, 89, 129...)
    const listSize = this.state.originalLogList.length;
    const listToShow = [];

    for (let i = listBeg; i <= listEnd; i++) {
      // If the list size has not been reached yet
      if (i < listSize) {
        listToShow.push(this.state.originalLogList[i]);
      }
      // If the list element === undefined
      else {
        break;
      }
    }
    this.setState({ activeLogList: listToShow }, () => {
      let myDiv = document.getElementById("main-table-container");
      myDiv.scrollTop = 0;
    });
  }

  buildAndRenderActiveFilteredLogPage = (activePageNumber) => {
    const listBeg = (activePageNumber - 1) * logListBeginMultiplier;         // Multiples of 50 (starting with 0)
    const listEnd = listBeg + logListEndMultiplier;                          // Multiples of 49 (49, 89, 129...)
    const listSize = this.state.filteredLogList.length;
    const listToShow = [];

    for (let i = listBeg; i <= listEnd; i++) {
      // If the list size has not been reached yet
      if (i < listSize) {
        listToShow.push(this.state.filteredLogList[i]);
      }
      // If the list element === undefined
      else {
        break;
      }
    }
    this.setState({ activeLogList: listToShow }, () => {
      let myDiv = document.getElementById("main-table-container");
      myDiv.scrollTop = 0;
    });
  }

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_LOG;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  // Returns a table row corresponding to the information contained in the log entry
  getLogEntryTableRow = (logEntry) => {
    let tableRow = "";

    // If the row background needs to be painted grey, get it painted
    if (shouldPaintRowWithGreyColor) {
      tableRow = <React.Fragment key={Math.random()}>
        <Table.Row style={paintedTableRowStyle} key={logEntry.time}>
          <Table.Cell verticalAlign="middle" width={1}>{this.formatTime(logEntry)}</Table.Cell>
          <Table.Cell verticalAlign="middle" width={1}>{logEntry.channel}</Table.Cell>
          <Table.Cell verticalAlign="middle" width={1}>{logEntry.typeText}</Table.Cell>
          <Table.Cell verticalAlign="middle" width={3}>{this.getDescriptionText(logEntry.type, logEntry.active)}</Table.Cell>
        </Table.Row>
      </React.Fragment>;
    }
    // otherwise, get it with a white background
    else {
      tableRow = <React.Fragment key={Math.random()}>
        <Table.Row key={logEntry.time}>
          <Table.Cell verticalAlign="middle" width={1}>{this.formatTime(logEntry)}</Table.Cell>
          <Table.Cell verticalAlign="middle" width={1}>{logEntry.channel}</Table.Cell>
          <Table.Cell verticalAlign="middle" width={1}>{logEntry.typeText}</Table.Cell>
          <Table.Cell verticalAlign="middle" width={3}>{this.getDescriptionText(logEntry.type, logEntry.active)}</Table.Cell>
        </Table.Row>
      </React.Fragment>;
    }

    shouldPaintRowWithGreyColor = !shouldPaintRowWithGreyColor;
    return (tableRow);
  }

  getDescriptionText = (problemType, isActive) => {
    if (problemType === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
      return isActive ? Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LOG_DESCRIPTION: Strings.EVENT_CHECKED_SUCCESS;
    }
    else if (problemType === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
      return isActive ? Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
    else if (problemType === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      return isActive ? Strings.FIBER_SIGNAL_LOSS_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    this.adjustTableMaxHeight();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.adjustTableMaxHeight, 5000) });
  }

  componentWillUnmount() {
    this.state.controller.abort();
    clearInterval(this.state.intervalID);
  }

  // Render the table containing log entries
  render() {
    const filter = this.state.formInput;

    const activeLogList = this.state.activeLogList.map(logEntry => (
      this.getLogEntryTableRow(logEntry)
    ));

    return (
      <div style={screenStyle}>

        <Grid id="grid-id" columns="equal" textAlign="center" verticalAlign="middle">
          <Grid.Row>

            <Grid.Column>
              {
                // Left blank on purpouse so that we don't lose the 3-column grid alignment
              }
            </Grid.Column>

            <Grid.Column>
              <Form style={searchStyle} onSubmit={this.handleSubmit} >
                <Form.Input
                  placeholder={Strings.LOG_INPUT_TEXT_PLACEHOLDER}
                  id="inputform"
                  icon="search"
                  name="formInput"
                  value={filter}
                  onChange={this.handleChange} />
              </Form>
            </Grid.Column>

            <Grid.Column>
              <Button
                floated='right'
                icon="refresh"
                color="teal"
                size="big"
                onClick={this.handleRefreshButtonClick} />
            </Grid.Column>

          </Grid.Row>
        </Grid>

        <Table style={headerMarginStyle} celled fixed singleLine textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={1}>
                {Strings.HORARY}
              </Table.HeaderCell>

              <Table.HeaderCell width={1}>
                {Strings.CHANNEL}
              </Table.HeaderCell>

              <Table.HeaderCell width={1}>
                {Strings.TYPE}
              </Table.HeaderCell>

              <Table.HeaderCell width={3}>
                {Strings.DESCRIPTION}
              </Table.HeaderCell>

            </Table.Row>

          </Table.Header>
        </Table>

        <div id="main-table-container" style={tableStyle}>
          <Table celled fixed textAlign="center">
            <Table.Body>{activeLogList}</Table.Body>
          </Table>
        </div>

        <div id="pagination-container"></div>

        <Loader size='big' active={this.state.isLoadingActive}>{Strings.LOG_WAITING}</Loader>

      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  margin: "2vh 2vw",
  textAlign: "center",
};

const headerMarginStyle = {
  marginTop: "16px",
  marginBottom: "8px",
  width: "99%"
};

const tableStyle = {
  overflowY: "scroll",
  marginBottom: "16px"
};

const searchStyle = {
  marginBottom: "8px",
  width: "100%"
};

const paintedTableRowStyle = {
  backgroundColor: "#f6f8fa"
};

export default withRouter(EventLogOLM);